export default __webpack_public_path__ + "static/media/babyceo copy 1.d2c61da7.png";